var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.2498 7.925L12.0665 11.75L8.2498 15.575L9.4248 16.75L14.4248 11.75L9.4248 6.75L8.2498 7.925Z",
    fill: "#C6CBD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDisabled);
export default __webpack_public_path__ + "static/media/chevron-right-disabled.e0a4dff1ca027c120d0930e7b3136e2a.svg";
export { ForwardRef as ReactComponent };